import angular from 'angular';
import _ from 'lodash';
import {fields} from './fields.js';
import swal from 'sweetalert';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        console.log(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(){
        return [
            {
                className: 'row',
                fieldGroup: [
                    _.extend({className: 'col-md-4'}, fields.broj_biopsije),
                    _.extend({className: 'col-md-4'}, fields.odgovoreno),
                    _.extend({className: 'col-md-4'}, fields.primljeno),
                ]
            },

            {
                wrapper:'fieldset',
                templateOptions: {
                    label: 'Pacijent'
                },
                fieldGroup: [
                    {
                        className:'col-md-6',
                        fieldGroup: [
                            fields.prezime,
                            fields.ime,
                            fields.sifra,
                        ]
                    },
                    {
                        className: 'col-md-6',
                        fieldGroup: [
                            fields.jmbg_oib,
                            fields.datum_rodjenja,
                            fields.spol,
                            fields.dob
                        ]
                    }
                ]
            },
            {
                wrapper:'fieldset',
                templateOptions: {
                    label: 'Uputnica'
                },
                fieldGroup: [
                    {
                        className:'col-md-6',
                        fieldGroup: [
                            fields.oznaka_vanjske_biopsije,
                            fields.dijagnoza_anamneza,
                        ]
                    },
                    {
                        className: 'col-md-6',
                        fieldGroup: [
                            fields.uputio,
                            fields.materijal,
                            fields.napomena,
                        ]
                    }
                ]
            },
            {
                wrapper:'fieldset',
                templateOptions: {
                    label: 'Nalaz biopsije'
                },
                fieldGroup: [
                    {
                        className:'col-md-6',
                        fieldGroup: [
                            fields.lijecnik,
                            fields.pataloska_dijagnoza,
                        ]
                    },
                    {
                        className: 'col-md-6',
                        fieldGroup: [
                            fields.tehnicar,
                            fields.pT_pN_pM,
                        ]
                    }
                ]
            },
            {
                className: 'row',
                fieldGroup: [
                    _.extend({className: 'col-md-12'}, fields.opis_nalaza_biopsije)
                ]
            }

        ];
    }
}

FormController.$inject = ['Uputnica'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/uputnica/form/form.controller.js